module.exports = __webpack_public_path__ + "img/avatar.a5462bd3.png";